export default "__VITE_ASSET__BBCnn$mL__"